import React, { useState } from "react";
import { Paper, Typography } from "@mui/material";
import List from "./List";
import Atomic from "../../AComponent/Atomic";
import Molecule from "../../MComponent/Molecule";
import Gateway from "../../Utils/Api/Gateway";
import URLs from "../../Utils/index";
import useWindowDimensions from "../../Utils/CustomHooks/WindowRezise";
import AddImageForm from "./AddImageForm";
import EwButton from "../../AComponent/Buttons/Button_3";
const { Input, Button } = Atomic;
const { EwModal } = Molecule;
const { TAM_URL } = URLs;

const svg1 = () => (
  <svg width="89" height="89" viewBox="0 0 89 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M74.1669 51.9165V59.3347H66.7498V66.7507H74.1669V74.1678H81.5829V66.7507H89V59.3347H81.5829V51.9165H74.1669Z"
      fill="black"
    />
    <path
      d="M40.7916 74.1676C40.7916 72.1172 39.1329 70.4585 37.0825 70.4585H29.6664C27.616 70.4585 25.9573 72.1172 25.9573 74.1676C25.9573 76.217 27.616 77.8756 29.6664 77.8756H37.0825C39.1329 77.8756 40.7916 76.217 40.7916 74.1676Z"
      fill="black"
    />
    <path
      d="M59.3334 74.1676V81.5836H7.41711V7.41711H59.3334V51.9176H66.7505V7.41711C66.7505 3.3354 63.4119 0 59.3334 0H7.41711C3.33865 0 0 3.3354 0 7.41711V81.5846C0 85.6619 3.33865 89.0006 7.41711 89.0006H59.3334C63.4119 89.0006 66.7505 85.6619 66.7505 81.5834V74.1674L59.3334 74.1676Z"
      fill="black"
    />
  </svg>
);
const MydeviceIcon = () => (
  <svg width="67" height="89" viewBox="0 0 67 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M40.7915 74.1676C40.7915 72.1172 39.1328 70.4585 37.0824 70.4585H29.6664C27.6159 70.4585 25.9573 72.1172 25.9573 74.1676C25.9573 76.217 27.6159 77.8756 29.6664 77.8756H37.0824C39.1328 77.8756 40.7915 76.217 40.7915 74.1676Z"
      fill="black"
    />
    <path
      d="M59.3334 74.1676V81.5836H7.41711V7.41711H59.3334V51.9176H66.7505V7.41711C66.7505 3.3354 63.4119 0 59.3334 0H7.41711C3.33865 0 0 3.3354 0 7.41711V81.5846C0 85.6619 3.33865 89.0006 7.41711 89.0006H59.3334C63.4119 89.0006 66.7505 85.6619 66.7505 81.5834V74.1674L59.3334 74.1676Z"
      fill="black"
    />
  </svg>
);

const ViewBdaAdminIcon = () => (
  <svg width="84" height="89" viewBox="0 0 84 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M61.1557 44.995H22.0736C16.2219 45.0018 10.6121 47.3214 6.47354 51.4453C2.33561 55.5691 0.00732163 61.1603 2.3437e-07 66.9927V86.1387C-0.000307264 86.8976 0.30198 87.6256 0.840465 88.1623C1.37893 88.699 2.10927 89.0003 2.8707 89H80.3555C81.1169 89.0003 81.8473 88.699 82.3857 88.1623C82.9242 87.6256 83.2265 86.8976 83.2262 86.1387V66.9927C83.2188 61.1604 80.8909 55.5695 76.7535 51.4453C72.6159 47.3214 67.0073 45.0021 61.1557 44.995ZM77.4856 83.2752H63.4569V68.6144C63.4569 67.5922 62.9098 66.6475 62.0217 66.1366C61.1333 65.6253 60.0391 65.6253 59.1507 66.1366C58.2626 66.6475 57.7152 67.5922 57.7152 68.6144V83.2752H29.1641L29.1644 68.6144C29.1644 67.5922 28.6171 66.6475 27.729 66.1366C26.8409 65.6253 25.7464 65.6253 24.8583 66.1366C23.9699 66.6475 23.4228 67.5922 23.4228 68.6144V83.2752H5.74202V66.9933C5.74786 62.6782 7.47026 58.5416 10.5319 55.4908C13.5936 52.4401 17.7445 50.7242 22.0738 50.7193H61.1559C65.4848 50.7245 69.6353 52.4409 72.6961 55.4916C75.7575 58.5424 77.4799 62.6788 77.4857 66.9934L77.4856 83.2752ZM41.6139 40.8135C45.6636 40.8135 49.6218 39.6166 52.9888 37.3738C56.3559 35.1314 58.9802 31.944 60.5295 28.2151C62.0791 24.4858 62.4841 20.3825 61.6937 16.4239C60.9034 12.4652 58.9529 8.82912 56.0889 5.9752C53.2253 3.12127 49.5766 1.17827 45.6044 0.391475C41.6328 -0.395314 37.5162 0.00956047 33.7752 1.55467C30.034 3.10008 26.8369 5.71649 24.588 9.07308C22.3392 12.4297 21.1392 16.3754 21.1401 20.4116C21.1478 25.8209 23.3072 31.0062 27.1453 34.8315C30.9835 38.6561 36.1866 40.8074 41.6139 40.8135ZM41.6139 5.723C45.5212 5.723 49.2683 7.26998 52.0307 10.0237C54.7932 12.7774 56.3456 16.5122 56.3456 20.4065C56.3456 24.3007 54.7935 28.0356 52.0307 30.7892C49.268 33.543 45.5209 35.09 41.6139 35.09C37.7069 35.09 33.9597 33.543 31.197 30.7892C28.434 28.0352 26.882 24.3004 26.882 20.4065C26.8866 16.5135 28.4402 12.781 31.202 10.0284C33.9638 7.27563 37.708 5.72732 41.6139 5.723Z"
      fill="black"
    />
  </svg>
);
const AddBdaAdminIcon = () => (
  <svg width="92" height="89" viewBox="0 0 92 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M61.1557 44.995H22.0736C16.2219 45.0018 10.6121 47.3214 6.47353 51.4452C2.33561 55.5691 0.00732163 61.1603 2.3437e-07 66.9927V86.1387C-0.000307264 86.8976 0.30198 87.6256 0.840465 88.1623C1.37893 88.699 2.10927 89.0003 2.8707 89H80.3555C81.1169 89.0003 81.8473 88.699 82.3857 88.1623C82.9242 87.6256 83.2265 86.8976 83.2262 86.1387V66.9927C83.2188 61.1604 80.8909 55.5695 76.7535 51.4452C72.6158 47.3214 67.0066 45.0014 61.155 44.9944L61.1557 44.995ZM77.4856 83.2752H63.4568V68.6144C63.4568 67.5922 62.9098 66.6475 62.0217 66.1366C61.1333 65.6253 60.0391 65.6253 59.1507 66.1366C58.2626 66.6475 57.7152 67.5922 57.7152 68.6144V83.2752H29.1641L29.1644 68.6144C29.1644 67.5922 28.6171 66.6475 27.729 66.1366C26.8409 65.6253 25.7464 65.6253 24.8583 66.1366C23.9699 66.6475 23.4228 67.5922 23.4228 68.6144V83.2752H5.74202V66.9933C5.74786 62.6782 7.47026 58.5416 10.5319 55.4908C13.5936 52.44 17.7445 50.7242 22.0738 50.7193H61.1559C65.4848 50.7245 69.6353 52.4409 72.6961 55.4916C75.7575 58.5424 77.4799 62.6788 77.4857 66.9933L77.4856 83.2752ZM41.6139 40.8135C45.6636 40.8135 49.6218 39.6166 52.9888 37.3738C56.3559 35.1314 58.9802 31.944 60.5295 28.2151C62.0791 24.4858 62.484 20.3825 61.6937 16.4239C60.9034 12.4652 58.9529 8.82912 56.0889 5.9752C53.2253 3.12127 49.5766 1.17827 45.6044 0.391475C41.6328 -0.395314 37.5162 0.0095604 33.7752 1.55467C30.034 3.10008 26.8369 5.71649 24.588 9.07308C22.3392 12.4297 21.1392 16.3754 21.1401 20.4116C21.1478 25.8209 23.3072 31.0062 27.1453 34.8315C30.9835 38.6561 36.1868 40.8072 41.6141 40.8133L41.6139 40.8135ZM41.6139 5.723C45.5212 5.723 49.2683 7.26998 52.0307 10.0237C54.7932 12.7774 56.3456 16.5122 56.3456 20.4065C56.3456 24.3007 54.7935 28.0356 52.0307 30.7892C49.268 33.543 45.5209 35.09 41.6139 35.09C37.7069 35.09 33.9597 33.543 31.197 30.7892C28.434 28.0352 26.882 24.3004 26.882 20.4065C26.8866 16.5135 28.4402 12.781 31.202 10.0284C33.9638 7.27563 37.7082 5.72716 41.6141 5.72285L41.6139 5.723ZM91.871 31.4014C91.871 32.1603 91.5687 32.8882 91.0302 33.425C90.4917 33.9613 89.7617 34.263 89.0003 34.263H82.1238V41.1169C82.1238 42.1391 81.5767 43.0838 80.6883 43.5948C79.8003 44.106 78.7057 44.106 77.8177 43.5948C76.9292 43.0838 76.3822 42.1391 76.3822 41.1169V34.263H69.5057C68.4802 34.263 67.5324 33.7177 67.0198 32.8322C66.5068 31.947 66.5068 30.8561 67.0198 29.9709C67.5324 29.0854 68.4802 28.5401 69.5057 28.5401H76.3822V21.6915C76.3822 20.6693 76.9293 19.7246 77.8177 19.2136C78.7057 18.7024 79.8003 18.7024 80.6883 19.2136C81.5768 19.7246 82.1238 20.6693 82.1238 21.6915V28.5454H89.0003C89.7608 28.5451 90.4905 28.8458 91.0287 29.3812C91.5668 29.917 91.8701 30.6435 91.871 31.4014V31.4014Z"
      fill="black"
    />
  </svg>
);
const endPointMap = {
  registerDevice: "/face-recognition/tam/device/register",
  activate: "/face-recognition/tam/device/installBDA",
  deactivate: "/face-recognition/tam/device/deactivate",
  getAllDevices: "/getAllDevices",
  addAdmin: "/user/add",
};
function RegisterDevice({ onClose }) {
  const [deviceState, setdeviceState] = useState({
    macId: "",
    workCode: "",
  });
  const { width } = useWindowDimensions();
  const { macId, workCode, workLocataionName } = deviceState;
  function updateDeviceData(val, type) {
    setdeviceState((prev) => ({ ...prev, [type]: val }));
  }

  function onSave() {
    if (macId === "" || workCode === "" || workLocataionName === "") {
      return;
    }
    let payload = {
      DeviceLocationID: workCode,
      DeviceID: macId,
      DeviceLocationName: workLocataionName,
    };
    Gateway({
      url: TAM_URL + endPointMap.registerDevice,
      payload,
    }).then((res) => {
      console.log("Result is: ", res);
      onClose();
    });
  }
  return (
    <>
      <div style={{ padding: 5, width: 0.5 * width }}>
        <div className="Flex">
          <Typography variant="h1">Add A Device</Typography>
        </div>

        <br />
        <div className="Flex">
          <Input
            label={"Mac Address"}
            value={macId}
            onChange={(val) => updateDeviceData(val, "macId")}
          />
          <br />
          <Input
            label={"Work Location Code"}
            value={workCode}
            onChange={(val) => updateDeviceData(val, "workCode")}
          />
          <br />
          <Input
            label={"Work Location Name"}
            value={workLocataionName}
            onChange={(val) => updateDeviceData(val, "workLocataionName")}
          />
          <br />
          <Button title={"Save"} onClick={onSave} />
        </div>
      </div>
    </>
  );
}
function AddAdmin() {
  const { width } = useWindowDimensions();
  const [adminState, setAdminState] = useState({
    email: "",
    phoneNumber: "",
    empCode: "",
    passowrd: "",
    deviceId: "",
  });

  function updateAdminData(val, type) {
    setAdminState((prev) => ({ ...prev, [type]: val }));
  }
  function onSave() {
    const { empCode, passowrd, deviceId, phoneNumber } = adminState;
    if (empCode === "" || passowrd === "" || deviceId === "" || phoneNumber === "") return;
    let payload = {
      EmpCode: empCode,
      Password: passowrd,
      EmailID: "",
      PhoneNumber: phoneNumber,
      UserRole: "BA",
      DeviceID: deviceId,
    };
    Gateway({
      url: TAM_URL + endPointMap.addAdmin,
      payload,
    }).then((res) => {
      console.log("res is: ", res);
    });
  }
  return (
    <>
      <div style={{ padding: 5, width: 0.5 * width }}>
        <div className="Flex">
          <Typography variant="h1">Add Admin</Typography>
          <br />
          {Object.keys(adminState).map((ele) => (
            <Input
              // type={ele === "password" ? "password" : "text"}
              value={adminState[ele]}
              onChange={(val) => updateAdminData(val, ele)}
              label={ele}
            />
          ))}
          <br />
          <Button title="Save" onClick={() => {}} />
          <br />
        </div>
      </div>
    </>
  );
}
function TAM() {
  const [modal, setModal] = useState(null);
  const [tab, setTab] = useState(null);
  const list = [
    {
      name: "Register new device",
      Svg: svg1,
      id: "RD",
    },
    {
      name: "My Devices",
      Svg: MydeviceIcon,
      id: "MD",
    },
    {
      name: "BDA Admins",
      Svg: ViewBdaAdminIcon,
      id: 3,
    },
    {
      name: "Add BDA Admin",
      Svg: AddBdaAdminIcon,
      id: "AD",
    },
  ];

  function returnModalContent() {
    if (modal === "RD") {
      return <RegisterDevice onClose={() => setModal(null)} />;
    }
    if (modal === "AD") {
      return <AddAdmin />;
    }
    return <></>;
  }

  return (
    <>
      <EwModal open={modal ? true : false} onClose={() => setModal(null)}>
        {returnModalContent()}
      </EwModal>

      {tab === null ? (
        <div style={{ height: 500 }} className="Flex-row g20">
          {list.map(({ name, Svg, id }) => (
            <div
              onClick={() => {
                if (id === "RD" || id === "AD") setModal(id);
                if (id === "MD") setTab(id);
              }}
            >
              <Paper className="pointer Flex" style={{ width: 300, borderRadius: 0, height: 300 }}>
                <div className="Flex">
                  <div>
                    <Svg />
                  </div>
                  <br />
                  {name}
                </div>
              </Paper>
            </div>
          ))}
        </div>
      ) : (
        <>
          <List setTab={setTab} />
        </>
      )}
    </>
  );
}

export default TAM;
